import {ref} from 'vue';

type ltbTypeOptions = 'ice' | 'ev';

export default function useLookingToBuyTabs() {
    const ltbTab = ref( 'ice' as ltbTypeOptions);

    const changeLtbTab = (tab: ltbTypeOptions) => {
        ltbTab.value = tab;
    };

    return {
        ltbTab,
        changeLtbTab,
    };
}
